import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signIn, currentIdToken, SignInResult } from '../auth/cognito';
import { useT } from '../i18n';

export function AdminLogin() {
  const t = useT();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [challenge, setChallenge] = useState<Extract<SignInResult, { status: 'newPasswordRequired' }> | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    void currentIdToken().then((t) => {
      if (t) navigate('/admin/games', { replace: true });
    });
  }, [navigate]);

  const handle = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = challenge
        ? await challenge.complete(newPassword)
        : await signIn(email.trim(), password);
      if (res.status === 'newPasswordRequired') {
        setChallenge(res);
      } else {
        navigate('/admin/games', { replace: true });
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : t('login.failed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card centered">
      <h1>{t('login.title')}</h1>
      {error && <div className="banner error">{t(error)}</div>}
      <form onSubmit={handle} className="stack">
        {!challenge ? (
          <>
            <label>
              {t('login.email')}
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
            </label>
            <label>
              {t('login.password')}
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
            </label>
          </>
        ) : (
          <>
            <p className="muted">{t('login.firstSignin')}</p>
            <label>
              {t('login.newPassword')}
              <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} autoComplete="new-password" />
            </label>
          </>
        )}
        <button type="submit" className="primary" disabled={busy}>
          {busy ? t('login.signingIn') : challenge ? t('login.setPassword') : t('login.signin')}
        </button>
      </form>
    </div>
  );
}
